<template>
  <div class="main">
    <div id="camera" ref="camera">
      <js-camera
        id="js-camera"
        ref="js-camera"
        audio="false"
        facing="back"
      ></js-camera>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Logger from '../../../lib/logger';
import 'js-camera';

export default {
  props: {
    selfie: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    videoStream: null,
    camera: null,
  }),
  computed: {
    ...mapState('onboarding', ['cameraOpened']),
  },
  methods: {
    ...mapActions('onboarding', ['setCameraOpened']),
    isDeniedError(error) {
      if (!error) return false;
      if (/NotAllowedError/ig.test(error.name)) return true;
      if (/denied/ig.test(error.message)) return true;
      return false;
    },
    emitPermissionError(e, isDenied = true) {
      const error = e || new Error('Permission denied');
      error.isDeniedError = isDenied;
      this.$emit('error', error);
    },
    registerCameraEvents() {
      this.camera.on('opened', () => {
        this.$emit('start');
      });
    },
    async openCamera() {
      if (!this.camera) this.$emit('error', new Error('Camera not settled up'));
      const permStatus = await this.camera.permission();
      if (permStatus === 'denied') {
        this.emitPermissionError();
        return;
      }
      try {
        this.$emit('onStarting');
        await this.camera.open(this.selfie ? 'front' : 'back');
        this.setCameraOpened({ opened: true });
        return;
      } catch (error) {
        const isDeniedError = this.isDeniedError(error);
        if (!isDeniedError) Logger.error(error);
        this.emitPermissionError(error, isDeniedError);
      }
    },
    capture() {
      if (!this.camera || !this.camera.opened) return null;
      const base64 = this.camera.capture({ format: 'image/jpeg' });
      return base64;
    },
    closeCamera() {
      this.camera.close();
      this.setCameraOpened({ opened: false });
    },
  },
  mounted() {
    this.camera = this.$refs['js-camera'];
    this.registerCameraEvents();
  },
};
</script>

<style lang="scss" scoped>
  .main { position: fixed; }

  #camera, #camera-track {
    position: fixed;
    height: 100vh;
    width: 100%;
    box-sizing: border-box;
  }

  .main::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1;
    border-top: 108px solid rgba(33, 43, 54, 0.5);
    border-right: 24px solid rgba(33, 43, 54, 0.5);
    border-bottom: 96px solid rgba(33, 43, 54, 0.5);
    border-left: 24px solid rgba(33, 43, 54, 0.5);
    background-clip: border-box;
  }
</style>
